import { processReceipt } from './services'
import { uploadReceiptToS3 } from 'shared/utils/receiptUpload'

export const uploadReceiptForReimbursement = async (file: File) => {
  try {
    const uploadResult = await uploadReceiptToS3(file)
    if (uploadResult.status === 'error') {
      return uploadResult
    }

    const processResponse = await processReceipt(
      uploadResult.downloadUrl,
      file.type
    )
    if (!processResponse?.data) {
      return { status: 'error', error: 'Receipt processing failed' }
    }

    return {
      status: 'success',
      downloadUrl: processResponse.data.downloadUrl ?? '',
      contentType: processResponse.data.contentType ?? '',
      receipts: processResponse.data.receipts ?? [],
    }
  } catch (error) {
    return { status: 'error', error: (error as Error).message }
  }
}
